import React from "react"
import { Link, graphql } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faClock,
  faTag,
  faFolderOpen,
  faSync,
  faChevronRight,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons"
import ButtonBase from "@material-ui/core/ButtonBase"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Image from "../../components/atoms/image"
import Bio from "../../components/bio"
import Social from "../../components/social_btn"
import JsonLd from "../../components/jsonLd"
import ArticleContent from "../../components/articleContent"
import "../../styles/article.css"

const BlogPage = ({ data }) => {
  const post = data.microcmsBlog
  const url = data.site?.siteMetadata.siteUrl + "/blog/" + post.slug
  const allData = data.allMicrocmsBlog?.nodes
  const index = allData?.findIndex(content => content.blogId === post.blogId)
  const prev = allData?.[index - 1] || null
  const next = allData?.[index + 1] || null
  return (
    <Layout>
      <Seo title={post.title} image={post.thumbnail?.url} />
      <JsonLd
        type={"post"}
        title={post.title}
        description={post.description || post.excerpt}
        imageUrl={post.thumbnail?.url}
        date={post.createdAt}
        update={post.updatedAt || null}
        category={post.category.name}
      />
      <div id="article">
        <header className="mb-6">
          <div className="mb-1">
            <FontAwesomeIcon icon={faFolderOpen} className="mr-1" />
            <Link
              to={`/categories/${post.category.name}/`}
              className="text-gray-600 no-underline"
            >
              {post.category.name}
            </Link>
          </div>
          <h1 className="mt-0" itemProp="headline">
            {post.title}
          </h1>
          <div className="mb-2 flex flex-wrap">
            <div className="mr-4">
              <FontAwesomeIcon icon={faClock} className="mr-1" />
              {post.createdAt}
            </div>
            {post.updatedAt !== post.createdAt && (
              <div>
                <FontAwesomeIcon icon={faSync} className="mr-1" />
                {post.updatedAt}
              </div>
            )}
          </div>
          <div id="tags" className="flex flex-wrap">
            {post.tags.map(tag => {
              return (
                <div
                  className="py-1 px-2 mr-2 mb-1 border rounded-md text-sm border-indigo-200 z-10"
                  key={tag.name}
                >
                  <Link
                    to={`/tags/${tag.name}/`}
                    className="text-gray-600 no-underline"
                  >
                    <FontAwesomeIcon icon={faTag} className="mr-1" />
                    {tag.name}
                  </Link>
                </div>
              )
            })}
          </div>
        </header>
        {post.thumbnail?.url && (
          <Image
            url={post.thumbnail.url}
            width={post.thumbnail.width}
            alt={post.title}
          />
        )}
        <ArticleContent contents={data.microcmsBlog.contents} />
      </div>
      <Social url={url} title={post.title} />
      <hr />
      <Bio />
      <hr />
      {(prev || next) && (
        <div className="flex relative items-center divide-x">
          <div className="w-1/2">
            {prev && (
              <ButtonBase
                component={Link}
                className="block max-w-full"
                to={`/blog/${prev.slug}`}
              >
                <div className="flex items-center max-w-full">
                  <FontAwesomeIcon icon={faChevronLeft} />
                  <div className="text-sm md:text-base flex-grow px-2 md:px-6 py-2 overflow-ellipsis overflow-hidden whitespace-nowrap md:whitespace-normal">
                    {prev.title}
                  </div>
                </div>
              </ButtonBase>
            )}
          </div>
          <div className="w-1/2">
            {next && (
              <ButtonBase
                component={Link}
                className="block max-w-full"
                to={`/blog/${next.slug}`}
              >
                <div className="flex items-center max-w-full">
                  <div className="text-sm md:text-base flex-grow px-2 md:px-6 py-2 overflow-ellipsis overflow-hidden whitespace-nowrap md:whitespace-normal">
                    {next.title}
                  </div>
                  <FontAwesomeIcon icon={faChevronRight} />
                </div>
              </ButtonBase>
            )}
          </div>
        </div>
      )}
    </Layout>
  )
}
export default BlogPage

export const query = graphql`
  query ($id: String!) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    microcmsBlog(id: { eq: $id }) {
      blogId
      slug
      contents {
        html
        rich
      }
      category {
        name
      }
      tags {
        name
      }
      title
      thumbnail {
        width
        height
        url
      }
      createdAt(formatString: "YYYY/MM/DD")
      description
      updatedAt(formatString: "YYYY/MM/DD")
    }
    allMicrocmsBlog {
      nodes {
        blogId
        title
        slug
      }
    }
  }
`
